import React from 'react';
export const usePopOver = () => {
    const triggerRef = React.useRef(null);
    const [show, setShow] = React.useState(false);
    const handleShow = () => setShow(true);
    const handleHide = () => setShow(false);
    const togglePopOver = () => setShow(!show);
    const handleEsc = (e) => {
        if (e.code === 'Escape') {
            handleHide();
        }
    };
    const getState = () => show;
    React.useEffect(() => {
        if (show) {
            document.addEventListener('keydown', handleEsc);
        }
        return () => {
            document.removeEventListener('keydown', handleEsc);
        };
    }, [show]);
    return {
        getState,
        handleHide,
        handleShow,
        togglePopOver,
        show,
        triggerRef,
    };
};
//# sourceMappingURL=use-pop-over.js.map